import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const getUserGroup = createAsyncThunk('/group/getUserGroup',
    async (group) => {
        try {
            const myurl = `${PAY_URL}/user/get-group`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const groupData = response.data;
            // console.log(groupData, "getUserGroup response");

            if (groupData.success === true) {
                return groupData;
            } else {
                throw new Error(groupData.message);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const getUserGroupSlice = createSlice({
    name: "getUserGroup",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserGroup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserGroup.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getUserGroup.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getUserGroupSlice.reducer;